module.exports = __webpack_public_path__ + "static/media/application_cluster.536c1145.svg";